import { colorReducer } from './slices/color';
import { configReducer } from './slices/config';
import { insuranceReducer } from './slices/insurance';
import { layoutReducer } from './slices/layout';
import { mixMatchReducer } from './slices/mixmatch';
import { modalsReducer } from './slices/modals';
import { pdWebReducer } from './slices/pdWeb';
import { prescriptionReducer } from './slices/prescription';
import { virtualMirrorReducer } from './slices/virtualMirror';
import { workflowReducer } from './slices/workflow';

const rootReducer = {
  config: configReducer,
  workflow: workflowReducer,
  modals: modalsReducer,
  prescription: prescriptionReducer,
  color: colorReducer,
  layout: layoutReducer,
  insurance: insuranceReducer,
  virtualMirror: virtualMirrorReducer,
  pdWeb: pdWebReducer,
  mixmatch: mixMatchReducer,
};

export default rootReducer;
